/* Imports */
import api from '@/shared/util/api';
const { http } = api.getInstance();

/* Actions */
import {
  TRANSIT_ORDER_ORIGIN_RANCHER_REQUEST,
  TRANSIT_ORDER_DESTINY_RANCHER_REQUEST,
  TRANSIT_TRAVEL_ORIGIN_RANCHER_REQUEST,
  TRANSIT_TRAVEL_DESTINY_RANCHER_REQUEST,
  TRANSIT_ORDER_ORIGIN_FARM_REQUEST,
  TRANSIT_ORDER_DESTINY_FARM_REQUEST,
  TRANSIT_TRAVEL_ORIGIN_FARM_REQUEST,
  TRANSIT_TRAVEL_DESTINY_FARM_REQUEST,
  TRANSIT_TRACKING_TYPES_REQUEST,
  TRANSIT_OPERATIONAL_SITUATION_REQUEST,
  TRANSIT_STATUS_PROPOSAL_REQUEST,
  TRANSIT_DRIVERS_REQUEST,
  TRANSIT_PARTNER_MAP_REQUEST,
  TRANSIT_DRIVER_MAP_REQUEST,
  TRANSIT_TRAVEL_DRIVER_DETACHED_FORM_REQUEST
} from './actions';

/* Vuex Auth Mutations */
const mutations = {};

/* Vuex Auth Actions */
const actions = {
  [TRANSIT_TRAVEL_DRIVER_DETACHED_FORM_REQUEST]: ({ commit }: any, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.search) {
        queryParams.push(`name=${requestData.search}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbsviagem-avulsa/motorista?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_ORDER_ORIGIN_RANCHER_REQUEST]: ({ commit }: any, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.search) {
        queryParams.push(`name=${requestData.search}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbspedido/parceiro/origem/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_ORDER_DESTINY_RANCHER_REQUEST]: ({ commit }: any, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.search) {
        queryParams.push(`name=${requestData.search}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbspedido/parceiro/destino/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_TRAVEL_ORIGIN_RANCHER_REQUEST]: ({ commit }: any, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.search) {
        queryParams.push(`name=${requestData.search}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbsviagem/parceiro/origem/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_TRAVEL_DESTINY_RANCHER_REQUEST]: ({ commit }: any, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.search) {
        queryParams.push(`name=${requestData.search}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbsviagem/parceiro/destino/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_ORDER_ORIGIN_FARM_REQUEST]: ({ commit }: any, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.id) {
        queryParams.push(`idParceiro=${requestData.id}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbspedido/fazenda/origem/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_ORDER_DESTINY_FARM_REQUEST]: ({ commit }: any, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.id) {
        queryParams.push(`idParceiro=${requestData.id}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbspedido/fazenda/destino/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_TRAVEL_ORIGIN_FARM_REQUEST]: ({ commit }: any, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.id) {
        queryParams.push(`idParceiro=${requestData.id}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbsviagem/fazenda/origem/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_TRAVEL_DESTINY_FARM_REQUEST]: ({ commit }: any, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.id) {
        queryParams.push(`idParceiro=${requestData.id}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbsviagem/fazenda/destino/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_TRACKING_TYPES_REQUEST]: () => {
    return new Promise < void > ((resolve, reject) => {
      http({
          method: 'get',
          url: '/transportadora/jbsparceiro/rastreamento/tipos',
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_OPERATIONAL_SITUATION_REQUEST]: () => {
    return new Promise < void > ((resolve, reject) => {
      http({
          method: 'get',
          url: '/transportadora/jbsparceiro/situacao-operacional/tipos',
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_STATUS_PROPOSAL_REQUEST]: () => {
    return new Promise < void > ((resolve, reject) => {
      http({
          method: 'get',
          url: '/transportadora/jbspedido/proposta-contrato-status-tipos',
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_DRIVERS_REQUEST]: ({ commit }, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.search) {
        queryParams.push(`name=${requestData.search}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbsparceiro/motorista?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_PARTNER_MAP_REQUEST]: ({ commit }, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.search) {
        queryParams.push(`name=${requestData.search}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbsviagem/parceiro/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [TRANSIT_DRIVER_MAP_REQUEST]: ({ commit }, requestData: any) => {
    return new Promise < void > ((resolve, reject) => {
      const queryParams = [`page=${requestData.page}`, `size=${requestData.size}`];
      if (requestData.search) {
        queryParams.push(`name=${requestData.search}`);
      }
      http({
          method: 'get',
          url: `/transportadora/jbsviagem/motorista/busca?${queryParams.join('&')}`,
        })
        .then(({
          data
        }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  actions,
  mutations,
};